import { Util } from './_util.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import Swiper from 'swiper/bundle';
import Headroom from 'headroom.js';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const App = {
  checkTouchDevice: function () {
    if ("ontouchstart" in document.documentElement){
      $('body').addClass('touch-device');
    } else {
      $('body').addClass('no-touch-device');
    }
  },

  controlMainMenu: function () {
    const MENU_BG = 'tan',
          MENU_HOVERS = ['blue', 'gold', 'orange', 'purple'];

    // Panel is always tan; links hover in the other colors, shuffled on each open
    function colorMainMenu() {
      const hovers = MENU_HOVERS.slice().sort(() => Math.random() - 0.5),
            $menu = $('.main-menu');

      $menu.addClass(`main-menu--bg-${MENU_BG}`);

      $menu.find('.main-menu__link').each(function (i) {
        $(this).removeClass(MENU_HOVERS.map((c) => `main-menu__link--hover-${c}`).join(' '))
               .addClass(`main-menu__link--hover-${hovers[i % hovers.length]}`);
      });
    }

    function openMainMenu() {
      colorMainMenu();
      $('.header').addClass('header--open');
      $('.main-menu').scrollTop(0);
      $('.main-menu__toggle-btn').addClass('main-menu__toggle-btn--close');
      $('html').addClass('hidden');

      // Keep the header in place while the menu is open
      if (App.headroom) {
        App.headroom.pin();
        App.headroom.freeze();
      }
    }

    function closeMainMenu() {
      $('.header').removeClass('header--open');
      $('.main-menu__toggle-btn').removeClass('main-menu__toggle-btn--close');
      $('html').removeClass('hidden');

      if (App.headroom) App.headroom.unfreeze();
    }

    $('.main-menu__toggle-btn').on('click',function(){
      if($(this).hasClass('main-menu__toggle-btn--close')){
        closeMainMenu();
      } else {
        openMainMenu();
      }
    });
  },

  // Header hides on scroll down, reappears on scroll up (like oneteam.co)
  initHeadroom: function () {
    const header = document.querySelector('.header');
    if (!header || !Headroom.cutsTheMustard) return;

    App.headroom = new Headroom(header, {
      offset: header.offsetHeight,
      tolerance: { up: 5, down: 0 },
      classes: {
        initial: 'header--headroom',
        pinned: 'header--pinned',
        unpinned: 'header--hide',
        top: 'header--top',
        notTop: 'header--not-top',
        bottom: 'header--bottom',
        notBottom: 'header--not-bottom',
        frozen: 'header--frozen',
      },
    });
    App.headroom.init();
  },

  initSwipers: function () {
    this.initHeroSlider();
    this.initHighlightSliders();
    this.initFeaturedProjects();
    this.initCarousels();
  },

  // Hero: fading project slider with progress tabs
  initHeroSlider: function () {
    const DELAY = 6000,
          SPEED = 1000;

    $('.js-hero-slider').each(function () {
      const $slider = $(this),
            $tabs = $slider.find('.hero-module__tab');

      if ($slider.find('.swiper-slide').length < 2) return;

      // Progress bar duration = autoplay delay + transition
      this.style.setProperty('--hero-delay', `${DELAY + SPEED}ms`);

      const setTabs = (index) => {
        $tabs.removeClass('hero-module__tab--active hero-module__tab--done');
        $tabs.each((i, tab) => {
          if (i < index) $(tab).addClass('hero-module__tab--done');
        });
        const active = $tabs.get(index);
        void active.offsetWidth; // restart the CSS animation
        $(active).addClass('hero-module__tab--active');
      };

      const swiper = new Swiper(this, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: SPEED,
        rewind: true,
        autoplay: { delay: DELAY, disableOnInteraction: false },
        on: {
          slideChange: (s) => setTabs(s.realIndex),
        },
      });

      $tabs.on('click', function () {
        swiper.slideTo($(this).data('index'));
      });

      setTabs(0);
    });
  },

  // Highlight: fading text + image slider with 01/02/03 tabs
  initHighlightSliders: function () {
    $('.js-highlight-slider, .js-tab-slider').each(function () {
      const swiper = new Swiper(this, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 800,
        rewind: true,
        autoHeight: true,
        autoplay: { delay: 7000, disableOnInteraction: false },
      });

      $(this).on('click', '.tabs__tab', function () {
        swiper.slideTo($(this).data('index'));
      });
    });
  },

  // Featured projects: "Latest Work" carousel with 01 / 06 counter
  initFeaturedProjects: function () {
    $('.js-featured-projects').each(function () {
      const $module = $(this),
            $current = $module.find('.js-slider-current');

      new Swiper($module.find('.js-slider').get(0), {
        slidesPerView: 1.35,
        spaceBetween: 15,
        speed: 600,
        navigation: {
          prevEl: $module.find('.js-slider-prev').get(0),
          nextEl: $module.find('.js-slider-next').get(0),
        },
        breakpoints: {
          761: { slidesPerView: 2.3, spaceBetween: 25 },
          1201: { slidesPerView: 3.6, spaceBetween: 40 },
        },
        on: {
          slideChange: (s) => $current.text(String(s.realIndex + 1).padStart(2, '0')),
        },
      });
    });
  },

  // Carousel module: "story" (one slide + copy) or "gallery" (auto-width images).
  // Space between slides always equals the section's left padding (gutter).
  initCarousels: function () {
    $('.js-carousel').each(function () {
      const $module = $(this),
            $current = $module.find('.js-slider-current'),
            isGallery = 'gallery' === $module.data('variant'),
            wrapper = $module.closest('.section__wrapper').get(0),
            gutter = () => parseFloat(getComputedStyle(wrapper).paddingLeft) || 0;

      new Swiper($module.find('.js-slider').get(0), {
        slidesPerView: isGallery ? 'auto' : 1,
        spaceBetween: gutter(),
        speed: 700,
        autoHeight: !isGallery,
        navigation: {
          prevEl: $module.find('.js-slider-prev').get(0),
          nextEl: $module.find('.js-slider-next').get(0),
        },
        on: {
          // The gutter is fluid (clamp), so re-read it whenever the window resizes
          beforeResize: (s) => { s.params.spaceBetween = gutter(); },
          slideChange: (s) => $current.text(String(s.realIndex + 1).padStart(2, '0')),
        },
      });
    });
  },

  // Accordion module
  initAccordions: function () {
    $('.js-accordion').on('click', '.accordion-module__trigger', function () {
      const $item = $(this).closest('.accordion-module__item'),
            isOpen = $item.hasClass('accordion-module__item--open');

      $item.toggleClass('accordion-module__item--open', !isOpen);
      $(this).attr('aria-expanded', !isOpen);
      $item.find('.accordion-module__panel').stop().slideToggle(400);
    });
  },

  // People grid: open a bio panel under the clicked person's row.
  // Height animates in CSS (.people-grid-module__panel--open).
  initPeopleGrid: function () {
    const DURATION = 600;

    $('.js-people-grid').each(function () {
      const $list = $(this).find('.people-grid-module__list');
      let $openPerson = null,
          busy = false;

      const headerOffset = () => $('.header').outerHeight() || 0;
      const html = document.documentElement;
      let scrollFrame = null;

      // Frame-by-frame scroll, re-aimed every frame at a live target, so it
      // stays in step with the panel animation in every browser (no reliance
      // on native smooth scrolling or scroll anchoring).
      const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
      const stopScroll = () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = null;
        html.style.overflowAnchor = '';
        window.removeEventListener('wheel', stopScroll);
        window.removeEventListener('touchstart', stopScroll);
      };
      const scrollToTarget = (getTarget) => {
        stopScroll();
        const startY = window.scrollY,
              startTime = performance.now();
        html.style.overflowAnchor = 'none';
        // Let the visitor take over at any point
        window.addEventListener('wheel', stopScroll, { passive: true });
        window.addEventListener('touchstart', stopScroll, { passive: true });

        const frame = (now) => {
          const t = Math.min(1, (now - startTime) / DURATION),
                maxY = html.scrollHeight - window.innerHeight,
                target = Math.max(0, Math.min(maxY, getTarget()));
          window.scrollTo({ top: startY + (target - startY) * ease(t), behavior: 'instant' });
          if (t < 1) scrollFrame = requestAnimationFrame(frame);
          else stopScroll();
        };
        scrollFrame = requestAnimationFrame(frame);
      };

      // Wait for the panel's height transition (with a fallback timer)
      const afterTransition = ($panel, callback) => {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          $panel.off('transitionend.bio');
          callback();
        };
        $panel.on('transitionend.bio', (e) => {
          if (e.target === $panel.get(0) && 'grid-template-rows' === e.originalEvent.propertyName) finish();
        });
        setTimeout(finish, DURATION + 100);
      };

      const closePanel = (callback, scrollBack) => {
        const $panel = $list.find('.people-grid-module__panel');
        const $person = $openPerson;

        if ($openPerson) {
          $openPerson.removeClass('person--open').find('.person__trigger').attr('aria-expanded', 'false');
          $openPerson = null;
        }
        if (!$panel.length) return callback && callback();

        // Closing from inside the bio: glide back up to the person while it collapses
        if (scrollBack && $person) {
          const personTop = () => $person.offset().top - headerOffset() - 30;
          if (personTop() < window.scrollY) scrollToTarget(personTop);
        }

        $panel.removeClass('people-grid-module__panel--open');
        afterTransition($panel, () => {
          $panel.remove();
          if (callback) callback();
        });
      };

      const openPanel = ($person) => {
        // Last person in the same visual row
        const top = $person.offset().top;
        let $rowEnd = $person;
        $person.nextAll('.person').each(function () {
          if (Math.abs($(this).offset().top - top) > 5) return false;
          $rowEnd = $(this);
        });

        const $inner = $('<div class="people-grid-module__panel-inner"></div>')
          .append($person.find('template.person__bio').prop('content').cloneNode(true));
        const $panel = $('<li class="people-grid-module__panel"></li>').append($inner);
        $rowEnd.after($panel);

        $person.addClass('person--open').find('.person__trigger').attr('aria-expanded', 'true');
        $openPerson = $person;

        $panel.get(0).offsetHeight; // commit the closed state before animating
        $panel.addClass('people-grid-module__panel--open');
        scrollToTarget(() => $panel.offset().top - headerOffset());
        afterTransition($panel, () => { busy = false; });
      };

      $list.on('click', 'button.person__trigger', function () {
        if (busy) return;
        const $person = $(this).closest('.person');
        busy = true;

        if ($person.hasClass('person--open')) {
          return closePanel(() => { busy = false; });
        }
        closePanel(() => openPanel($person));
      });

      $list.on('click', '.js-bio-close', () => {
        if (busy) return;
        busy = true;
        closePanel(() => { busy = false; }, true);
      });
    });
  },

  // Projects grid filter: fade the current items out, swap, fade the new set in
  initProjectsFilter: function () {
    const FADE = 350,
          STAGGER = 50;

    $('.js-projects-grid').each(function () {
      const $module = $(this),
            $items = $module.find('.projects-grid-module__item');
      let timer = null,
          run = 0;

      const matches = (el, filter) => 'all' === filter
        || ('featured' === filter && 1 === $(el).data('featured'))
        || $(el).data('type') === filter;

      $module.on('click', '.projects-grid-module__filter-btn', function () {
        const $btn = $(this),
              filter = $btn.data('filter');
        if ($btn.hasClass('projects-grid-module__filter-btn--active')) return;

        $module.find('.projects-grid-module__filter-btn').removeClass('projects-grid-module__filter-btn--active');
        $btn.addClass('projects-grid-module__filter-btn--active');

        const thisRun = ++run;
        clearTimeout(timer);

        // 1. Fade out what's showing
        $items.not('.projects-grid-module__item--hidden').addClass('projects-grid-module__item--out');

        // 2. Swap the set, then fade the new items in one after another
        timer = setTimeout(() => {
          $items.each(function () {
            const show = matches(this, filter);
            $(this).toggleClass('projects-grid-module__item--hidden', !show)
                   .toggleClass('projects-grid-module__item--out', show);
          });

          const $shown = $items.not('.projects-grid-module__item--hidden');
          void $module.get(0).offsetHeight; // commit the faded-out state

          $shown.each(function (i) {
            setTimeout(() => {
              if (thisRun === run) $(this).removeClass('projects-grid-module__item--out');
            }, i * STAGGER);
          });
        }, FADE);
      });
    });
  },

  // Single project image markers
  initMarkers: function () {
    $('.marker').each(function () {
      // Open the card to the left when the marker sits on the right half
      if (parseFloat(this.style.left) > 55) $(this).addClass('marker--flip');
      // Bottom-align the card when the marker sits in the lower half
      if (parseFloat(this.style.top) > 50) $(this).addClass('marker--bottom');
    });

    $(document).on('click', '.marker__dot', function (e) {
      e.stopPropagation();
      const $marker = $(this).closest('.marker'),
            isOpen = $marker.hasClass('marker--open');
      $('.marker--open').removeClass('marker--open').find('.marker__dot').attr('aria-expanded', 'false');
      if (!isOpen) {
        $marker.addClass('marker--open');
        $(this).attr('aria-expanded', 'true');
      }
    });

    $(document).on('click', () => {
      $('.marker--open').removeClass('marker--open').find('.marker__dot').attr('aria-expanded', 'false');
    });
  },

  // Smooth scrolling: hero down-arrow + intro anchor menu
  initScrollLinks: function () {
    $('.js-scroll-next').on('click', function () {
      const next = $(this).closest('section').next('section').get(0);
      if (next) next.scrollIntoView({ behavior: 'smooth' });
    });

    $('.intro-module__menu-link').on('click', function (e) {
      const target = document.querySelector($(this).attr('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  },

  getCopyrightYear: function () {
    const currentTime = new Date(),
          currentYear = currentTime.getFullYear();
    $('.footer .year').html(currentYear);
  },

  init: function () {
    this.checkTouchDevice();
    this.initHeadroom();
    this.controlMainMenu();
    this.initSwipers();
    this.initScrollLinks();
    this.initAccordions();
    this.initPeopleGrid();
    this.initProjectsFilter();
    this.initMarkers();
    this.getCopyrightYear();
  },
};

export default App;
